
import {HomeScreen} from "./screens/home/Home";
import {AppScreen} from "./screens/app/App";
import {AppHomeScreen} from "./screens/app/AppHome";
import {ObjectScreen} from "./screens/object/Object";
import {RecordScreen} from "./screens/record/Record";
import {ErrorScreen} from "./screens/error/Error";
import {PopupHandlerScreen} from "./screens/oauth/PopupHandler"
import {AuthenticationScreen} from "./screens/authentication/Authentication";
//import {DocumentationScreen} from './screens/documentation/Documentation';
import {CustomPageScreen} from './screens/customPage/CustomPage';
import {AppPageScreen} from './screens/appPage/AppPage';
import TuneIcon from "@mui/icons-material/TuneRounded";


export type AppRouteType = {
  label: string;
  component: React.ComponentType;
  children: AppRouteType[];
  type: 'public' | 'protected';
  path?: string;
  index?: boolean;
}

export const routes: AppRouteType[] = [
    {
      label: "Home",
      path: "/",
      component: HomeScreen,
      type: 'public',
      children: []
    },
    {
      label: "OAuth",
      path: "/oauth/popup-handler",
      component: PopupHandlerScreen,
      type: 'public',
      children: []
    },
    {
      label: "Login",
      path: "/login",
      component: AuthenticationScreen,
      type: 'public',
      children: []
    },
/*
    {
      label: "Documentation",
      path: "/docs/*",
      component: DocumentationScreen,
      type: 'public',
      children: []
    },
*/
    {
      label: "AppScreen",
      path: "/:appName",
      component: AppScreen,
      type: 'protected',
      children: [
        {label: "AppHomeScreen",
         index: true,
         component: AppHomeScreen,
         type: 'protected',
         children: []
       },
        {label: "ObjectScreen",
         path: ":objectName",
         component: ObjectScreen,
         type: 'protected',
         children: []
       },
       {
          label: "RecordScreen",
          path: ":objectName/:recordUuid",
          component: RecordScreen,
          type: 'protected',
          children: []
        },
        {
          label: "SearchScreen",
          path: "appPage/:appPageName",
          component: AppPageScreen,
          type: 'protected',
          children: []
       },
        {
          label: "SearchScreen",
          path: "customPage/:customPageName",
          component: CustomPageScreen,
          type: 'protected',
          children: []
       }
      ]
    },
    {
      label: "Error",
      path: "/main/*/hallo",
      component: HomeScreen,
      type: 'protected',
      children: []
    },
    {
      label: "Error",
      path: "*",
      component: ErrorScreen,
      type: 'public',
      children: []
    },
];
